import { verifyBeforeUpdateEmail } from 'firebase/auth';
import { auth } from '../firebase/firebase-config';
import { resolveFirebaseAuthError } from '../platform/authErrorMessages';
import { getPasswordResetContinueUrl } from './passwordResetService';

export function normalizeProfileEmail(email) {
  return String(email || '').trim().toLowerCase();
}

export function isValidProfileEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizeProfileEmail(email));
}

export const EMAIL_VERIFICATION_SENT_MESSAGE =
  'Na nov elektronski naslov smo poslali povezavo za potrditev. Prijava se posodobi šele po potrditvi.';

export async function requestProfileEmailUpdate(newEmail) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Uporabnik ni prijavljen.');
  }

  const normalized = normalizeProfileEmail(newEmail);
  if (!normalized) {
    throw new Error('Vnesite elektronski naslov.');
  }

  if (!isValidProfileEmail(normalized)) {
    throw new Error('Neveljaven elektronski naslov.');
  }

  if (normalizeProfileEmail(user.email) === normalized) {
    return false;
  }

  try {
    await verifyBeforeUpdateEmail(user, normalized, {
      url: getPasswordResetContinueUrl(),
      handleCodeInApp: false,
    });
    return true;
  } catch (error) {
    throw new Error(resolveFirebaseAuthError(error, { context: 'emailUpdate' }));
  }
}
